<template>
  <div class="wrap">
    <div class="header">
      <div class="header-top">
        <img src="../images/kecheng_fanhui.png" @click="backLastPage" style="cursor: pointer;width: 24px;height: 24px;" />
        <h3 class="title">{{this.query.course_name }}</h3>
        <div class="search-box">
          <div v-if="keyword !== ''" class="kecheng_souan" @click="homeworkListByChapter">搜索</div>
          <img class="kecheng_sst" src="../images/kcsoutp.png" />
          <el-input class="kecheng_sousuo" placeholder="搜索章、节名称" @input="handleSearchls" v-model="keyword">
            <!-- <i slot="suffix" class="el-icon-search" @click="handleSearch"></i> -->
          </el-input>
        </div>
      </div>
      <div class="header-bottom">
        <div>班期：{{this.query.class_name }}</div>
        <!-- <div>章节：{{this.query.chapter_id?this.query.chapter_name:this.query.section_name}}</div> -->
      </div>
    </div>
    <div class="option" style="display: flex;">
      <div>
        <el-button :class="status==1?'active':''" @click="changeOption(1)">待完成</el-button>
        <div :class="status==1?'tab_xiahua':''"></div>
      </div>
      <div>
        <el-button :class="status==2?'active':''" @click="changeOption(2)">已完成</el-button>
        <div :class="status==2?'tab_xiahua':''"></div>
      </div>
      <div>
        <el-button :class="status==3?'active':''" @click="changeOption(3)">草稿箱</el-button> 
        <div :class="status==3?'tab_xiahua':''"></div>
      </div>
    </div>
    <div class="course-content">
      <div v-if="chapterlist.length !== 0">
        <div v-if="chapterlist[0].zhankai == false" class="content_zjlist"></div>
      </div>
      <div v-for="(itema, index) in chapterlist" :key="index">
        <div :class="!itema.zhankai?'content_zj':'content_zjyi'" >
          <div style="display: flex; cursor: pointer; user-select: none; flex: 1;" @click="shouqizj(itema)">
            <div>
              <img v-show="!itema.zhankai" class="content_zjsq" src="../images/zjsq.png" alt="">
              <img v-show="itema.zhankai" class="content_zjsq" src="../images/zjzk.png" alt="">
            </div>
            <div class="content_zjname">{{itema.name}}</div>
          </div>
          <div class="content_zjdwc">{{ status == 2 ? '已完成' : '待完成' }}
            <span v-if="status == 2" style="color: #10B881; font-weight: 500;">{{itema.homework_count}}</span>
            <span v-else style="color: #FF7D00;font-weight: 500;">{{itema.homework_count}}</span>
          </div>
        </div>
        <table v-if="itema.zhankai" class="table">
          <tr class="table-header" :style="status==2 || status==3?'grid-template-columns: 18fr 18fr 18fr 18fr 24fr 11fr':''">
            <th>作业名称</th>
            <th v-if="status == 1 || status == 3">发布时间</th>
            <th v-if="status == 1 || status == 3">截止时间</th>
            <th v-if="status == 1 || status == 3">题目数量</th>
            <th v-else-if="status == 2">批改状态</th>
            <th v-if="status == 2">成绩</th>
            <th v-if="status == 2">是否迟交</th>
            <th v-if="status != 1">做题模式</th>
            <th>操作</th>
          </tr>
          <tr class="table-vott" v-for="item of itema.homework_list" :key="item.homework_id" :style="status==2 || status==3?'grid-template-columns: 18fr 18fr 18fr 18fr 24fr 11fr':''">
            <td style="height: 72px;">
              <span v-if="status == 1">{{ item.homework_name }}</span>
              <span v-else>{{ item.name }}</span>
            </td>
            <td style="height: 72px;">
              <span v-if="status == 2">
                <span style="color: #FF7D00;" v-if="item.status == 1">待批阅</span>
                <span v-if="item.status == 2">已批阅</span>
              </span>
              <span v-else>{{item.create_time }}</span>
            </td>
            <td style="height: 72px;">
              <span style="color: #286BFF;" v-if="status == 2">{{ item.score }}</span>
              <span v-else>{{item.end_time }}</span>
            </td>
            <td style="height: 72px;">
              <span v-if="status == 2">
                <span style="color: #F53F3F;" v-if="item.is_late == 1">迟交</span>
                <span v-if="item.is_late == 0">未迟交</span>
              </span>
              <span v-else>
                <span v-if="status == 1">{{item.question_count }}</span>
                <span v-if="status == 3">{{ item.sum }}</span>
              </span>
            </td>
            <td v-if="status != 1" style="height: 72px;">{{ item.mode == 1 ? '考试模式' : '逐题模式' }}</td>
            <td v-if="status == 1" style="color:#1872ED; font-size:14px;cursor:pointer" @click="toQuestionPaperPage(item,'do')">写作业</td>
            <td v-else style="color:#1872ED; font-size:14px;"  class="operate">
              <!-- <span v-if="status == 2 && item.status == 2" @click="toQuestionPaperPage(item,'check')">{{item.status == 1?'查看详情':'查看评语'}}</span> -->
              <span v-if="status == 2 && item.status == 1" :class=" item.mode == 3 ? 'finishGrandstand' : ''" @click="item.mode !== 3 ? toQuestionPaperPage(item,'edit') : ''">修改作业</span>
              <div v-if="status == 2 && item.status == 2">
                <span style="margin-right: 10px;" @click="toQuestionPaperPage(item, 'doPractice')">巩固</span>
                <span @click="toQuestionPaperPage(item,'check')">查看</span>
              </div>
              <span v-if="status == 3 && item.status == 1" @click="toQuestionPaperPage(item,'edit')">写作业</span>
            </td>
          </tr>
        </table>
      </div>
      <el-empty v-if="!chapterlist.length" description="暂无数据"></el-empty>
    </div>
    <div class="pagination" v-if="chapterlist.length">
      <el-pagination background :page-size="10"  :current-page.sync="page" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
    <div class="xt_tanc">
      <el-dialog :visible.sync="isPracticeMode" :show-close="false" width="720px" >
        <work-mode-dialog :exerciseData="exerciseData" :modeDialogType="modeDialogType" @selectMode="selectMode" @practiceClick="practiceClick" @close="workModeDialogClose" />
      </el-dialog>
      <el-dialog :visible.sync="dialogVisibleck" :show-close="false" width="720px" >
        <historyList :dialogVisibleck="dialogVisibleck" :exerciseData="exerciseData" :payload="xzysh" @Taozzye="Taozzye" @historyListClose="dialogVisibleck = false" />
        <div style="height: 24px;"></div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import workModeDialog from './workModeDialog.vue'
import historyList from './historyList.vue'
export default {
  components: { workModeDialog, historyList },
  data() {
    return {
      seachKey:'',
      pagination: {
        page: 1,
        total: 0,
        num: 6,
      },
      status:1,
      page:1,
      homeworkDetailList:[],
      total:0,
      showTotal:0,
      drafts: 0,
      compete: 0,
      keyword: '',
      chapterlist: [],
      isPracticeMode: false,
      ksms: 0,
      xzysh: {},
      ywcgglx: 0,
      dialogVisibleck: false,
      modeDialogType: 1,
      exerciseData: {}
    }
  },
  props:{
    query:{
      type:Object,
      default(){
        return{}
      }
    }
  },
  computed:{
    isLate(){
      return function(create_time,end_time){
        if(new Date(create_time).getTime()>new Date(end_time).getTime()){
          return '迟交'
        }else{
          return '未迟交'
        }
      }
    }
  },
  created() {
    console.log('activeName',this.query.activeName)
    console.error('query~~~~~~~',this.query)
    this.status = this.query.activeName || 1
    this.showTotal = this.query.unFinished || 0
    // this.getHomeWorkDetailList()
    this.homeworkListByChapter(0)
    console.log('gsd13255=====')
  },
  methods: {
    Taozzye(item) {
      this.xzysh = { ...this.xzysh, isConsolidation: true, isShowSubmit: false, type: 'check', consolidationId: item.id, workScore: item.score, isHistory: true }
      this.$emit('changePage',{page:'GraduallyTi',query:{ ...this.xzysh }})
    },
    xuanzestgglx(item) {
       if (item == 0) {
         this.ywcgglx = 0
       } else {
        this.ywcgglx = 1
       }
    },
    xuanzest(item) {
       if (item == 0) {
         this.ksms = 0
       } else {
        this.ksms = 1
       }
    },
    shouqizj(index) {
      if(index.zhankai == true) {
        this.$set(index, 'zhankai', false)
      } else {
        this.$set(index, 'zhankai', true)
      }
      // this.chapterlist[index].zhankai = !this.chapterlist[index].zhankai;
      console.log(this.chapterlist)
    },
    handleSearchls() {
      if (this.keyword === '') {
        this.homeworkListByChapter()
      }
    },
    async homeworkListByChapter(item) {
      const {course_id, class_id,} = this.query
          const data = {
            page:this.page,
            page_nums:10,
            course_id,
            class_id,
            keyword: this.keyword
          }
          if (item == 0) {
            data.read_class = 1
          } else {
            data.read_class = 0
          }
          if(this.status == 2) {
            data.flag = 0
          }else if (this.status == 3) {
            data.flag = 1
          }
          const api = this.status == 1?'/user/index/homeworkListByChapter':'/user/index/chapterTaskAlready'
          const res = await this.$axios.post(api, data)
          if(res.data.code == 200){
            if (item == 0) {
              this.$emit('changePage',{page:'HomeworkDetail', query: this.query})
            }
            if (res.data.data.list.lenght !== 0) { 
              res.data.data.list.forEach((element, index) => {
                // if (index == 0) {
                //   element.zhankai = true
                // } else {
                  element.zhankai = false
                // }
              });
            }
            this.chapterlist = res.data.data.list
            this.total = res.data.data.count
            console.log('干嘛的的====', this.chapterlist)
          }
    },
    handleCurrentChange(val){
      this.page = val
      // this.getHomeWorkDetailList()
      this.homeworkListByChapter()
    },
    backLastPage(){
      this.$emit('changePage',{page:'HomeworkList'})
    },
    async getHomeWorkDetailList(){
      const {course_id,
          class_id,
          chapter_id,
          section_id} = this.query
      const data = {
        page:this.page,
        page_nums:10,
        course_id,
        class_id,
        chapter_id,
        section_id
      }
      if(this.status == 2) {
        data.flag = 0
      }else if (this.status == 3) {
        data.flag = 1
      }
      const api = this.status == 1?'/user/index/not':'/user/index/already'
      const res = await this.$axios.post(api,data)
      if(res.data.code == 200){
        this.homeworkDetailList = res.data.data.chapter_question
        // if(this.status == 1){
        //   this.showTotal = res.data.data.count
        // }
        if (res.data.data.incomplete != undefined) {
          this.showTotal = res.data.data.incomplete // 待完成
          this.compete = res.data.data.compete // 已完成
          this.drafts = res.data.data.drafts // 草稿箱
          if(this.status === 1){
            this.total = res.data.data.incomplete 
          }else if(this.status === 2){
            this.total = res.data.data.compete
          }else{
            this.total = res.data.data.drafts
          }
        }
      }
    },
    changeOption(val){
      this.status = val
      this.page = 1
      // this.getHomeWorkDetailList()
      this.homeworkListByChapter()
    },
    xzexinbanb () {
      this.$emit('changePage',{page:'QuestionPaper',query:this.xzysh })
    },
    toQuestionPaperPage(item,type){
      const payload = {...this.query,...item,...{type},...{activeName:this.status},...{unFinished:this.showTotal} }
      // 之前query中的qt_id可能是会从内页带出来的 所以需判断里面是否与带过来的qt_id一致 如果一致则将qt_id置空 重新获取
      if (payload.qt_id != payload.homework_id && !item.qt_id) {
        payload.qt_id = ''
      }
      payload.qt_id = payload.qt_id || payload.homework_id
      payload.titleName = this.status === 1 ? item.homework_name : item.name
      this.xzysh = { ...payload }
      this.xzysh.isConsolidation = false
      this.modeDialogType = item.mode
      if (this.status === 1) {
        this.xzysh.flag = 1
      }
      let flag = 2 
      if (type == 'check') {
          flag = 0
      }
      this.xzysh.flag = flag
      if (type == 'check') {
        this.xzysh.isShowSubmit = false
      } else {
        this.xzysh.isShowSubmit = true
      }
      this.xzysh.isHistory = false
      if (type == 'doPractice') {
        console.log('点击了巩固练习')
        this.modeDialogType = 1
        this.getconsolidationData(item.ucqid)
        return
      }
      if (item.mode == 2 && (type == 'doPractice' || type == 'do')) {
        this.isPracticeMode = true
        return
      }
      if (item.mode === 1) {
        this.$emit('changePage',{page:'QuestionPaper',query: { ...this.xzysh } })
      } else {
        this.$emit('changePage',{page:'GraduallyTi',query: { ...this.xzysh } })
      }
    },
    selectMode(type) {
      /* 1：考试模式 2：逐题模式 */
      this.xzysh = { ...this.xzysh, modeType: type, isConsolidation: this.xzysh.type == 'doPractice' ? true : false }
      console.log('选择的模式', this.xzysh)
      if (type === 2) {
        this.$emit('changePage',{page:'GraduallyTi',query:{ ...this.xzysh }})
      } else {
        this.$emit('changePage',{page:'QuestionPaper',query:{ ...this.xzysh }})
      }
    },
    practiceClick() {
      this.dialogVisibleck = true
    },
    getconsolidationData(ucqid) {
      this.$axios.post('/user/question/stat', { ucq_id: ucqid }).then(res => {
          if (res.data.code == 200) {
              this.isPracticeMode = true
              this.exerciseData = res.data.data
          } else {
              this.$message.error(res.data.message)
          }
      })
    },
    workModeDialogClose() {
      this.isPracticeMode = false
    }
  },
}
</script>

<style lang="scss" scoped>
li,
ul,
p,
h4 {
  margin: 0;
  padding: 0;
  list-style: none;
}
th{
  font-weight: normal;
}
.wrap {
  background: #ffffff;
  margin: 25px 0px 25px 25px;
  float: left;
  padding: 20px 0 20px 30px;
  max-height: 753px;
  box-sizing: border-box;
  .xt_tanc {
    .zyfs_cddw {
      width: 672px;
      height: 92px;
      background: #ffffff;
      border: 1px solid #e3e8e9;
      border-radius: 8px;
      margin: 0 auto;
      margin-top: 7.5px;
      .zyfs_jgbzbjg {
        width: 52px;
        height: 25px;
        background: #ff8982;
        border-radius: 8px 0px 8px 0px;
        position: relative;
        z-index: 1;
        text-align: center;
        line-height: 25px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #ffffff;
      }
      .zyfs_jgbz {
        width: 40px;
        height: 25px;
        background: #10b881;
        border-radius: 8px 0px 8px 0px;
        position: relative;
        z-index: 1;
        text-align: center;
        line-height: 25px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #ffffff;
      }
      .zyfs_whx {
        width: 648px;
        height: 76px;
        background: #f6f7f9;
        border-radius: 8px;
        margin: 0 auto;
        margin-top: -16px;
        display: flex;
        .zyfs_cktm {
          width: 104px;
          height: 48px;
          margin-top: 10.5px;
          .zyfs_cktman {
            width: 80px;
            height: 36px;
            background: #eaf1ff;
            border-radius: 100px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            text-align: center;
            color: #286bff;
            line-height: 36px;
            margin: 0 auto;
            margin-top: 6px;
          }
        }
        .zyfs_wcsj {
          width: 144px;
          height: 48px;
          border-right: 1px solid #dadce0;
          text-align: center;
          margin-top: 10.5px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          color: #848586;
        }
        .zyfs_yibai {
          width: 304px;
          height: 48px;
          border-right: 1px solid #dadce0;
          text-align: center;
          margin-top: 10.5px;
          display: flex;
          .zyfs_ztsyb {
            width: 101px;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-400;
            font-weight: 400;
            color: #848586;
            .zyfs_ztsyib {
              font-size: 18px;
              font-family: PingFang SC, PingFang SC-600;
              font-weight: 600;
              color: #202020;
              margin-top: 6.5px;
            }
          }
        }
        .zyfs_bas {
          width: 96px;
          height: 48px;
          border-right: 1px solid #dadce0;
          text-align: center;
          margin-top: 10.5px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          color: #848586;
          .zyfs_zyfsbsf {
            font-size: 24px;
            font-family: DINPro, DINPro-700;
            font-weight: 700;
            color: #286bff;
            margin-top: 4px;
            .zyfs_fsdf {
              font-size: 12px;
              font-family: PingFang SC, PingFang SC-400;
              font-weight: 400;
              color: #848586;
              margin-left: 4px;
            }
          }
        }
      }
    }
    .lxls_fs {
      width: 672px;
      height: 62px;
      background: #f4f6f6;
      border-radius: 8px;
      display: flex;
      margin: 0 auto;
      margin-top: 24px;
      .lxls_jgcs {
        width: 224px;
        height: 63px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        text-align: center;
        color: #848586;
        margin-top: 8px;
        .lxls_fsse {
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-600;
          font-weight: 600;
          color: #202020;
          margin-top: 2px;
        }
      }
    }
    .gglx_zhz {
      display: flex;
      margin: 0 auto;
      width: 672px;
      height: 65px;
      margin-top: 24px;
      .gglx_jpg {
        display: flex;
        width: 556px;
        height: 65px;
        background: #f4f6f6;
        border-radius: 8px;
        .gglx_jgsa {
          width: 185px;
          height: 65px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          text-align: center;
          color: #848586;
          .gglx_fs {
            margin-top: 4px;
            font-size: 18px;
            font-weight: 600;
            color: #202020;
          }
        }
      }
      .gglx_lxcs {
        width: 104px;
        height: 65px;
        background: #eaf1ff;
        border-radius: 8px;
        text-align: center;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #286bff;
        margin-right: 12px;
      }
    }
    .xzksms_xzy {
      width: 200px;
      height: 32px;
      background: #286bff;
      border-radius: 8px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #ffffff;
      margin: 0 auto;
      margin-top: 24px;
    }
    .xzksms_kszt {
      display: flex;
      margin: 0 auto;
      width: 672px;
      margin-top: 24px;
      .xzksms_ksxz {
        width: 330px;
        height: 110px;
        background: #eaf1ff;
        border: 1px solid #286bff;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        .ksmo_xzan {
          margin-top: 19px;
          margin-right: 17px;
        }
        .ksmo_jx {
          font-size: 13px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          color: #848586;
          margin-top: 8px;
        }
        .ksms_wz {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          color: #202020;
          margin-top: 4px;
        }
        .ksmo_ks {
          width: 24px;
          height: 24px;
          margin-top: 16px;
        }
        ::v-deep  .el-radio__inner {
          width: 18px;
          height: 18px;
          border-radius: 50%;
        }
        ::v-deep .el-radio__input.is-checked .el-radio__inner {
          width: 18px;
          height: 18px;
          border-radius: 50%;
        }
        ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
          transform: translate(-50%, -50%) scale(1);
          content: "";
          width: 9px;
          height: 4px;
          border: 2px solid #fff;
          border-top: transparent;
          border-right: transparent;
          text-align: center;
          display: block;
          position: absolute;
          top: 4.5px;
          left: 3px;
          vertical-align: middle;
          -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
          border-radius: 0;
          background: none;
        }
        ::v-deep .el-radio__label  {
          display: none;
        }
      }
      .xzksms_ks {
        width: 330px;
        height: 110px;
        border: 1px solid #f0f4f5;
        border-radius: 8px;
        display: flex;
        justify-content: space-between;
        .ksmo_xzan {
          margin-top: 19px;
          margin-right: 17px;
        }
        .ksmo_jx {
          font-size: 13px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          color: #848586;
          margin-top: 8px;
        }
        .ksms_wz {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 400;
          color: #202020;
          margin-top: 4px;
        }
        .ksmo_ks {
          width: 24px;
          height: 24px;
          margin-top: 16px;
        }
        ::v-deep  .el-radio__inner {
          width: 18px;
          height: 18px;
          border-radius: 50%;
        }
        ::v-deep .el-radio__input.is-checked .el-radio__inner {
          width: 18px;
          height: 18px;
          border-radius: 50%;
        }
        ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
          transform: translate(-50%, -50%) scale(1);
          content: "";
          width: 9px;
          height: 4px;
          border: 2px solid #fff;
          border-top: transparent;
          border-right: transparent;
          text-align: center;
          display: block;
          position: absolute;
          top: 4.5px;
          left: 3px;
          vertical-align: middle;
          -webkit-transform: rotate(-45deg);
          transform: rotate(-45deg);
          border-radius: 0;
          background: none;
        }
        ::v-deep .el-radio__label  {
          display: none;
        }
      }
    }
    .xzy_dtms {
      text-align: center;
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-600;
      font-weight: 600;
      color: #202020;
      padding-top: 24px;
      .gbdt_ms {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 24px;
      }
    }
    ::v-deep .el-dialog{
        border-radius: 16px;
      }
    ::v-deep .el-dialog__header{
        padding: 0px;
        padding-bottom: 0px;
      }
    ::v-deep .el-dialog__body {
      padding: 0;
      // height: 263px;
      background: #ffffff;
      border-radius: 16px;
    }
    
  }
  .header{
    padding: 0 30px 12px 0;
    .header-top{
      display: flex;
      align-items: center;
      // margin-bottom: 10px;
      .search-box{
      // width: 180px;
      margin-left: auto;
      ::v-deep .el-input__inner{
        border: none;
        background: #F7F7F7;
        border-radius:8px;
        padding-left: 36px;
        height: 32px;
      }
      ::v-deep .el-input__suffix{
        color: #1872ed;
      }
      ::v-deep .el-input__suffix{
        top: 9px;
        right: 10px;
        cursor: pointer;
      }
      .kecheng_souan {
        width: 90px;
        height: 32px;
        background: #286bff;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-400;
        font-weight: 400;
        color: #ffffff;
        position: absolute;
        z-index: 1;
        margin-left: 315px;
        border-radius: 0 8px 8px 0;
      }
      .kecheng_sst {
        width: 20px;
        height: 20px;
        position: absolute;
        margin-left: 28px;
        margin-top: 6px;
        z-index: 1;
      }
      .kecheng_sousuo {
        width: 390px;
        height: 32px;
        background: #f4f6f6;
        border-radius: 8px;
        margin-left: 16px;
      }
    }
      img{
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
    .header-bottom{
      display: flex;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #848586;
      margin-left: 30px;
      div{
        margin-right: 30px;
      }
    }
  }
}
.title {
  font-size: 20px;
  color: #202020;
  margin-bottom: 6px;
  margin-top: 6px;
}
.option{
  .tab_xiahua {
    width: 24px;
    height: 2px;
    background: #1872ed;
    border-radius: 2px;margin-left: 36px;
  }
  ::v-deep .el-button{
    border: none;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-400;
    font-weight: 400;
    color: #848586;
    border-radius: 17px;
    padding: 10px 23px;
    // font-size: 14px;
    line-height: 20px;
  }
  ::v-deep .el-button.active{
    background: #fff;
    color: #1872ED;
    font-weight: 500;
  }
}
.course-content {
  margin-top: 20px;
  padding: 0 20px 0 0;
  box-sizing: border-box;
  font-size: 14px;
  height: calc(753px - 100px - 42px - 40px - 20px - 20px - 12px);
  overflow-y: auto;
  .content_zjlist {
    width: 100%;
    border-bottom: 1px solid #f0f4f5;
  }
  .content_zj {
    width: 100%;
    height: 40px;
    background: #ffffff;
    // border-top: 1px solid #f0f4f5;
    border-bottom: 1px solid #f0f4f5;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    .content_zjdwc {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 500;
      color: #848586;
      margin-right: 12px;
    }
    .content_zjname {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 500;
      color: #202020;
      margin-left: 8px;
    }
    .content_zjsq {
      width: 16px;
      height: 16px;
      margin-left: 12px;
      margin-top: 13px;
    }
  }

  .content_zjyi {
    width: 100%;
    height: 40px;
    background: #f4f6f6;
    // border: 1px solid #e3e8e9;
    border-bottom: 1px solid #e3e8e9;
    border-radius: 8px 8px 0px 0px;
    // border-top: 1px solid #f0f4f5;
    // border-bottom: 1px solid #f0f4f5;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    .content_zjdwc {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 400;
      color: #848586;
      margin-right: 12px;
    }
    .content_zjname {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-400;
      font-weight: 500;
      color: #202020;
      margin-left: 8px;
    }
    .content_zjsq {
      width: 16px;
      height: 16px;
      margin-left: 12px;
      margin-top: 13px;
    }
  }
  .table{
    width: 100%;
    // border: 1px solid #e8eaec;
    border-collapse:collapse

  }
  .table .read{
    font-size: 12px;
    color: #202020;
  }
  .table .unread{
    font-size: 12px;
    color: #FFAB1B;
    }
  tr{
      width: 100%;
      display: grid;
      grid-template-columns: 19fr 18fr 18fr 18fr 7fr 1fr;
      justify-content: center;
      align-items: center;
      // min-height: 50px;
      th{
        // border-right: 1px solid #e8eaec;
        height: 36px;
        line-height: 36px;
        border-bottom: 1px solid #e8eaec;

      }
      th:last-child{
        border-right: none;
      }
      td{
        // border-right: 1px solid #e8eaec;
        // border-bottom: 1px solid #e8eaec;
        height: 100%;
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;
      }
      td:last-child{
        border-right: none;
      }
  }
  tr:first-child th{
    border-bottom: none;
  }
  tr:last-child td{
    border-bottom: none;
  }
  .table-header{
    width: 100%;
    background: #F5F6F7;
    color: #808695;
  }
  .table-vott {
    color: #202020;
  }
  .table-vott:hover {
    background: #f4f6f6;
    // border: 1px solid #e3e8e9;
    // border-radius: 8px 8px 0px 0px;
  }
}
.pagination {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
}
.pagination >>> .el-pager li:not(.disabled).active {
  background: #10a675;
}
.operate{
  display: flex;
  flex-direction: column;
  span {
    cursor:pointer;
  }
  .finishGrandstand {
    cursor: default;
    color: #9A9C9F;
  }
}
.operate span:nth-child(2){
  margin-top: 8px;
}
// .content_zj:nth-child(1) {
//   border-top: 1px solid #f0f4f5;
// }

</style>
